<template lang = 'pug'>
    v-container#wizard(tag="section")
      validation-observer(v-slot="{ valid }")
        base-material-wizard.mx-auto(v-model="tab" :available-steps="availableSteps" :items="tabs" @click:next="next(valid)" @click:prev="tab--")
          v-tab-item.pb-12
            form
              .text-center.display-1.font-weight-light.mb-6
                | Let's start with basic information (with validation)
              v-row.mx-auto(justify="space-around" style="max-width: 500px;")
                v-col.text-center(cols="auto")
                  input.d-none(ref="file" type="file" @change="onChange" accept='image/*')
                  v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="image ? 'success--text' : 'grey--text'" outlined="" height="106" width="106" @click="$refs.file.click()")
                    v-img(v-if="image" :src="image" height="100%" width="100%")
                    v-icon.mx-auto(v-else="" size="96")
                      | mdi-account
                  .font-weight-bold.grey--text
                    | CHOOSE PICTURE
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="first")
                    v-text-field(v-model="first" :error-messages="errors" color="secondary" label="First Name*" prepend-icon="mdi-face" validate-on-blur="")
                  validation-provider(v-slot="{ errors }" rules="required" name="last")
                    v-text-field(v-model="last" :error-messages="errors" color="secondary" label="Last Name*" prepend-icon="mdi-account" validate-on-blur="")
                v-col(cols="12")
                  validation-provider(v-slot="{ errors }" rules="required" name="email")
                    v-text-field(v-model="email" :error-messages="errors" color="secondary" label="Email*" prepend-icon="mdi-email" validate-on-blur="")
          v-tab-item.pb-12
            form
              v-responsive.mx-auto(max-width="500")
                .text-center.display-1.grey--text.font-weight-light.mb-6
                  | What are you doing? (checkboxes)
                validation-provider(rules="required" name="type")
                  input(:value="stringAccount" type="hidden")
                v-item-group.row(v-model="account" multiple="")
                  v-item(v-for="(account, i) in accounts" :key="i")
                    template(v-slot="{ active, toggle }")
                      v-col.text-center(cols="4")
                        v-card.mb-6.mx-auto.pa-10.d-inline-block.v-card--account(:class="active ? 'success--text' : 'grey--text'" outlined="" @click="toggle")
                          v-icon(large="" v-text="account.icon")
                        .text-uppercase.subtitle-2.text--primary(v-text="account.type")
          v-tab-item.pb-12
            .text-center.display-1.grey--text.font-weight-light.mb-6
              | Are you living in a nice area?
            form
              v-row.mx-auto(justify="space-around" style="max-width: 500px;")
                v-col(cols="12" md="8")
                  validation-provider(v-slot="{ errors }" rules="required" name="address")
                    v-text-field(v-model="address" :error-messages="errors" color="secondary" label="Street Name*" validate-on-blur="")
                v-col(cols="12" md="4")
                  validation-provider(v-slot="{ errors }" rules="required" name="street")
                    v-text-field(v-model="street" :error-messages="errors" color="secondary" label="Street Number*" validate-on-blur="")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="city")
                    v-text-field(v-model="city" :error-messages="errors" color="secondary" label="City*" validate-on-blur="")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="state")
                    v-autocomplete(v-model="state" :autocomplete="Date.now()" :error-messages="errors" :items="states" color="secondary" label="State*" validate-on-blur="")

</template>

<script>
  export default {
    name: 'DashboardFormsWizard',

    data: () => ({
      account: [],
      accounts: [
        {
          icon: 'mdi-pencil',
          type: 'design',
        },
        {
          icon: 'mdi-code-tags',
          type: 'code',
        },
        {
          icon: 'mdi-laptop',
          type: 'develop',
        },
      ],
      address: '',
      city: '',
      email: '',
      first: '',
      image: null,
      last: '',
      state: '',
      states: [
        'Alabama', 'Alaska', 'American Samoa', 'Arizona',
        'Arkansas', 'California', 'Colorado', 'Connecticut',
        'Delaware', 'District of Columbia', 'Federated States of Micronesia',
        'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
        'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
        'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
        'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
        'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
        'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
      ],
      street: '',
      tab: 0,
      tabs: ['Contacto', 'Cuenta', 'Dirección'],
    }),

    computed: {
      stringAccount () {
        return this.account.join(',')
      },
      scope () {
        if (this.tab === 0) return 'about'
        else if (this.tab === 2) return 'address'
        return 'account'
      },
      availableSteps () {
        const steps = [0]

        if (
          this.first &&
          this.last &&
          this.email
        ) steps.push(1)

        if (this.stringAccount && steps.includes(1)) steps.push(2)

        if (
          this.address &&
          this.street &&
          this.city &&
          this.state &&
          steps.includes(2)
        ) steps.push(3)

        return steps
      },
    },

    methods: {
      next (valid) {
        if (!valid) return

        if (this.tab === this.tabs.length - 1) {
          alert('Form finished')
        } else {
          this.tab++
        }
      },
      onChange (val) {
        const value = val.target.files[0]

        if (!value) return (this.image = null)

        this.image = URL.createObjectURL(value)
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
